exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ac-accordion {\n  background-color: #fff;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  border-width: 1px;\n  border-color: #edf2f7;\n}", ""]);

// exports
